import { render, staticRenderFns } from "./modifySaTitle.vue?vue&type=template&id=6435283f&scoped=true&"
import script from "./modifySaTitle.vue?vue&type=script&lang=js&"
export * from "./modifySaTitle.vue?vue&type=script&lang=js&"
import style0 from "./modifySaTitle.vue?vue&type=style&index=0&id=6435283f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6435283f",
  null
  
)

export default component.exports